import * as React from "react";
export default React.memo(function SvgWrap(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" role="presentation" {...props}><path d="M2 2v2h12V2zm0 12h2v-2H2zm8.5-7H2v2h8.5a1.5 1.5 0 0 1 0 3H8v-1.65L5 13l3 2.68V14h2.5a3.5 3.5 0 0 0 0-7" /></svg>;
});